import { render } from "./BlocklistForm.vue?vue&type=template&id=b076bb18&ts=true"
import script from "./BlocklistForm.vue?vue&type=script&lang=ts"
export * from "./BlocklistForm.vue?vue&type=script&lang=ts"

import "./BlocklistForm.vue?vue&type=style&index=0&id=b076bb18&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__